import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function LegalPage({ pageKey, title }) {
  const params = useParams();
  const key = pageKey || params.key;
  const [content, setContent] = useState("");

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get(`/pages/${key}`); setContent(data.content); } catch { /* noop */ }
    })();
  }, [key]);

  return (
    <div className="min-h-screen bg-sfc-night px-5 py-20 lg:px-10">
      <div className="mx-auto max-w-3xl">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white"><ArrowLeft size={16} /> Terug naar home</Link>
        <h1 className="mt-8 font-display text-4xl font-semibold text-white">{title}</h1>
        <div className="mt-8 whitespace-pre-line text-white/70 leading-relaxed">{content}</div>
      </div>
    </div>
  );
}
